import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Stylesheet
import "./ErrorMessage.scss";
export function ErrorMessage({ children, className }) {
  const errorClassName = classNames("error_message", className);

  return <span className={errorClassName}>{children}</span>;
}

ErrorMessage.propTypes = {
  className: PropTypes.any,
  children: PropTypes.any.isRequired,
};

export default ErrorMessage;
